// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/stepCard/stepCard.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/stepCard/stepCard.tsx");
  import.meta.hot.lastModified = "1730642741826.035";
}
// REMIX HMR END

import { motion } from "framer-motion";
import { Card, CardDescription } from "~/components/ui/card";
import { fadeIn } from "~/lib/variants";

// const MotionCard = motion(({ className, children }: { className: string }) => (
//   <Card className={className}>{children}</Card>
// ));

const StepCard = ({
  step,
  children
}) => {
  return <motion.div variants={fadeIn("down", 0.8, 1.3)} viewport={{
    once: true
  }} initial="hidden" whileInView="show" exit="hidden">
      <Card className="relative w-full h-full px-6 py-4 pt-6 flex justify-center items-start bg-card/40 backdrop-blur-sm md:px-6 lg:px-8 lg:py-6">
        <div className="absolute h-14 w-14 bg-violet-400/40 backdrop-blur -top-8 right-auto rounded-full flex items-center justify-center text-2xl font-poppins">
          <span>{step}</span>
        </div>
        <CardDescription className="text-lg text-white">
          {children}
        </CardDescription>
      </Card>
    </motion.div>;
};
_c = StepCard;
export default StepCard;
var _c;
$RefreshReg$(_c, "StepCard");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;